<template>
  <div>
    <!-- <cere-header :componentContent="componentContent"></cere-header> -->
    <!-- <cere-banner :componentContent="componentContent"></cere-banner> -->
    <div class="banner-filter">
      <!-- <div class="banner-filter-image" :style="`background-image:url(${curImageUrl.url});transition: all 1s;`"></div> -->
      <!-- <div class="banner-filter-image" :style="`background-color:${curImageUrl.backgroundColor};transition: all 1s;`"></div> -->
      <div class="flex-box hom-content-top pc-warp" >
        <cere-classification :componentContent="componentContent"></cere-classification>
        <BannerSwiper :componentContent="componentContent" :curImageUrl="curImageUrl"/>
        <BannerUserInfo/>
        <!-- <SettledPlatform/> -->
      </div>
    </div>
    
    
  </div>
</template>

<script>
  import CereClassification from './classification'
  import CereBanner from './banner'
  import BannerSwiper from './bannerSwiper'
  import BannerUserInfo from './bannerUserInfo'
  import CereHeader from './header'
  import SettledPlatform from './settledPlatform'
  export default {
    name: 'shopHeader',
    components: { CereHeader, CereBanner, CereClassification, SettledPlatform ,BannerSwiper,BannerUserInfo},
    props: {
      componentContent: {
        type: Object
      }
    },
    data(){
      return {
        curImageUrl:{
          url:'',
          backgroundColor:''
        },
      }
    },
    
  }
</script>

<style lang="scss" scoped>
  .hom-content-top{
    padding-bottom: 20px;
  }
  .pc-warp{
    width: 90%;
    max-width: 1612px;
    margin: 0 auto;
    position: relative;
    height: 653px;
    background: #fff;
  }
  .banner-filter{
    height: 100%;
    position: relative;
    overflow: hidden;
    background: #F3F3F3;
    .banner-filter-image{
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 33px;
      // height: 100%;
      // width: 100%;
      background-size:cover;
      background-position:center;
      // filter: blur(15px);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/canvasShow/cereshop/pc_b2c/shopHeader.vue